<template>
  <div>
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script >
export default {
  data() {
    return {
      color: 'rgba(76, 114, 109, 0.15)'
    }
  },
  created() {
    let brandColor;
    if (process.env.VUE_APP_STYLE === 'ederit') {
      this.color = 'rgba(255, 165, 52, 0.1)';
      brandColor = '#FFA534';
    } else if (process.env.VUE_APP_STYLE === 'ocb') {
      this.color = 'rgb(38,61,136, 0.1)';
      brandColor = 'rgb(38,61,136)';
    } else if (process.env.VUE_APP_STYLE === 'eterno') {
      this.color = 'rgba(13, 10, 7, 0.1)';
      brandColor = '#4C726D';
    } else if (process.env.VUE_APP_STYLE === 'drmatiasek') {
      this.color = '#c7f2ff';
      brandColor = '#1A9CD4';
    } else if (process.env.VUE_APP_STYLE === 'elbpneumologie') {
      this.color = '#EBF3F8';
      brandColor = '#176BA8';
    } else if (process.env.VUE_APP_STYLE === 'yuvell') {
      this.color = '#F8ECEC';
      brandColor = '#67144F';
    } else if (process.env.VUE_APP_STYLE === 'wah') {
      this.color = 'rgba(246, 238, 223, 0.1)';
      brandColor = 'rgb(129,171,180)';
    } else if (process.env.VUE_APP_STYLE === 'ahz') {
      this.color = '#C1DEED';
      brandColor = '#6375A8';
    } else if (process.env.VUE_APP_STYLE === 'assmann') {
      this.color = '#f2a0ae';
      brandColor = '#94666e';
    }
    else if (process.env.VUE_APP_STYLE === 'ivfs') {
      this.color = 'rgba(255, 165, 52, 0.1)';
      brandColor = '#F49F38';
    }
    else if (process.env.VUE_APP_STYLE === 'brunk') {
      this.color = 'rgba(102, 137, 150, 0.1)';
      brandColor = '#668996';
    }
    else if (process.env.VUE_APP_STYLE === 'san') {
      this.color = 'rgba(255, 165, 52, 0.1)';
      brandColor = '#FFA534';
    }
    else if (process.env.VUE_APP_STYLE === 'arco') {
      this.color = 'rgba(102, 137, 150, 0.1)';
      brandColor = '#C1AFA0';
    }
    else if (process.env.VUE_APP_STYLE === 'venaziel') {
      this.color = 'rgba(102, 137, 150, 0.1)';
      brandColor = '#B79B6E';
    }
    else if (process.env.VUE_APP_STYLE === 'fuehrer') {
      this.color = 'rgba(102, 137, 150, 0.1)';
      brandColor = '#B12122';
    }
    else {
      this.color = 'rgba(13, 10, 7, 0.1)';
      brandColor = '#4C726D'; // default to eterno
    }

    // Set the CSS custom property for the brand color
    document.documentElement.style.setProperty('--app-brand-color', brandColor);
  }
}
</script>

<style>
.table-striped tbody tr:nth-of-type(odd) {
  background: v-bind(color);
}
</style>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
